$( window ).on( 'load', () => {
	console.log( 'Loaded!' );
	//IE11 polyfill
	if ( 'NodeList' in window && ! NodeList.prototype.forEach ) {
		console.info( 'polyfill for IE11' );
		NodeList.prototype.forEach = function( callback, thisArg ) {
			thisArg = thisArg || window;
			for ( let i = 0; i < this.length; i++ ) {
				callback.call( thisArg, this[ i ], i, this );
			}
		};
	}
	// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
	( function( arr ) {
		arr.forEach( function( item ) {
			if ( item.hasOwnProperty( 'prepend' ) ) {
				return;
			}
			Object.defineProperty( item, 'prepend', {
				configurable: true,
				enumerable: true,
				writable: true,
				value: function prepend() {
					const argArr = Array.prototype.slice.call( arguments ),
						docFrag = document.createDocumentFragment();

					argArr.forEach( function( argItem ) {
						const isNode = argItem instanceof Node;
						docFrag.appendChild(
							isNode ? argItem : document.createTextNode( String( argItem ) )
						);
					} );

					this.insertBefore( docFrag, this.firstChild );
				},
			} );
		} );
	} ([Element.prototype, Document.prototype, DocumentFragment.prototype]));

	//check if we have modal__content - containers and if, add a close icon top left
	const addControlContentElements = () => {
		const createCloseIcon = () => {
			const icon = document.createElement( 'span' );
			icon.classList.add( 'icon' );
			icon.classList.add( 'icon--close' );
			icon.addEventListener( 'click', (e) => {
				const parent = e.target.parentNode;
				parent.classList.remove( 'visible' );
				console.log( 'Close the modal content' );
			} );
			return icon;
		};

		const createTabs = () => {
			const tabNames = [ 'Vita', 'Publikationen' ];
			const tabs = document.createElement( 'div' );
			tabs.classList.add( 'tab__wrap' );
			const createTab = (text) => {
				const tab = document.createElement( 'a' );
				tab.classList.add( 'tab' );
				tab.classList.add(
					text
						.toLowerCase()
						.trim()
						.split( ' ' )
						.join( '' )
				);
				tab.innerText = text;
				tab.href = '#';
				return tab;
			};
			tabNames.forEach( ( elem, idx ) => {
				tabs.appendChild( createTab( elem ) );
			} );
			tabs.addEventListener( 'click', (e) => {
				const targetTab = e.target;
				console.log( 'targetTab: ', targetTab );
				// targetTab.classList.contains( 'visible' );
				targetTab.parentNode.querySelectorAll( '.tab' ).forEach( ( elem, idx ) => {
					elem.classList.remove( 'visible' );
				} );
				targetTab.classList.add( 'visible' );
				let lookupClass = '';
				if ( targetTab.classList.contains( 'vita' ) ) {
					lookupClass = 'modal__tab-vita';
					targetTab.parentNode.parentNode
						.querySelector( '.' + lookupClass )
						.classList.add( 'visible' );
					targetTab.parentNode.parentNode
						.querySelector( '.modal__tab-publikationen' )
						.classList.remove( 'visible' );
				}
				if ( targetTab.classList.contains( 'publikationen' ) ) {
					lookupClass = 'modal__tab-publikationen';
					targetTab.parentNode.parentNode
						.querySelector( '.' + lookupClass )
						.classList.add( 'visible' );
					targetTab.parentNode.parentNode
						.querySelector( '.modal__tab-vita' )
						.classList.remove( 'visible' );
				}
				const relatedNode = targetTab.parentNode.parentNode.querySelector(
					'.' + lookupClass
				);
				if ( relatedNode ) {
					relatedNode.parentNode
						.querySelectorAll( '.visible' )
						.forEach( ( elem, idx ) => {
							elem.classList.remove( 'visible' );
						} );
					relatedNode.classList.add( 'visible' );
				}
				//detect whether it is necessary to add a scroll class to the relatedNode because the content might be too large for the available height in the overlay
				const nodeDims = relatedNode.getBoundingClientRect();
				const availableHeight =
          screen.availHeight -
          document.querySelector( 'main' ).getBoundingClientRect().top -
          screen.availWidth * 0.01; //last one: 1vw of border height
				console.warn(
					'Dimensions:',
					screen.availHeight,
					nodeDims.top,
					availableHeight,
					nodeDims
				);
				console.log( 'relatedNode:', relatedNode, availableHeight, nodeDims );
				if ( nodeDims.height > availableHeight ) {
					relatedNode.classList.add( 'scroll' );
				}
			} );
			return tabs;
		};
		const possibleModalContentElements = document.querySelectorAll(
			'.modal__content'
		);
		if ( possibleModalContentElements ) {
			possibleModalContentElements.forEach( ( elem, idx ) => {
				elem
					.querySelector( '.wp-block-group__inner-container' )
					.prepend( createTabs() );
				elem.appendChild( createCloseIcon() );
				elem.querySelector( '.tab.vita' ).click();
			} );
		}
	};
	addControlContentElements();

	const renderModal = function( target ) {
		const dialogTarget = document.querySelector( '[id="' + target + '"]' );
		if ( dialogTarget ) {
			console.log( 'ok, render this: ', dialogTarget );
			dialogTarget.classList.add( 'visible' );
		} else {
			console.warn( 'invalid target:_ ', dialogTarget );
		}
	};

	/**
   * Mobile menu handling
   *
   * @param e
   */
	const handleMobileMenuClick = (e) => {
		$mobileMenu.classList.toggle( 'active' );
		$mainMenu.classList.toggle( 'active' );
	};

	const $mainMenu = document.querySelector( '.main__menu-item' );
	var $mobileMenu = document.querySelector( '.nav__burger' );
	$mobileMenu.addEventListener( 'click', handleMobileMenuClick );

	window.renderModal = renderModal;

	/**
   * Mainpage animation
   */
	let animatedElements = document.querySelectorAll(
		'.invisible,.mainpage__logo'
	);
	if ( animatedElements && animatedElements.length ) {
		animatedElements.forEach( ( elem, idx ) => {
			elem.classList.remove( 'invisible' );
			elem.classList.add( 'animated' );
		} );
	}
} );
